module.exports = __webpack_public_path__ + "static/media/12.9d2b1024.png";